import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ReferralCard = ({ referral, type }) => {
  const statusConfig = {
    open: { label: 'Open', color: 'bg-primary/10 text-primary', icon: 'Circle' },
    ongoing: { label: 'Bezig', color: 'bg-warning/10 text-warning', icon: 'Clock' },
    completed: { label: 'Voltooid', color: 'bg-success/10 text-success', icon: 'CheckCircle2' },
    active: { label: 'Actief', color: 'bg-success/10 text-success', icon: 'Activity' },
    inactive: { label: 'Inactief', color: 'bg-muted text-muted-foreground', icon: 'Pause' }
  };

  const currentStatus = statusConfig?.[referral?.status] || statusConfig?.open;

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-5 transition-smooth hover:elevation-md"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        {type === 'contractor' && referral?.avatar && (
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg overflow-hidden flex-shrink-0">
            <Image 
              src={referral?.avatar} 
              alt={referral?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="font-heading font-semibold text-base md:text-lg text-foreground line-clamp-1">
              {referral?.title || referral?.name}
            </h3>
            <span className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium whitespace-nowrap ${currentStatus?.color}`}>
              <Icon name={currentStatus?.icon} size={12} />
              {currentStatus?.label}
            </span>
          </div>
          {referral?.company && (
            <p className="caption text-muted-foreground mb-2 line-clamp-1">{referral?.company}</p>
          )}
          {referral?.location && (
            <div className="flex items-center gap-1 text-muted-foreground mb-2">
              <Icon name="MapPin" size={14} />
              <span className="caption line-clamp-1">{referral?.location}</span>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4">
        {referral?.hoursWorked !== undefined && (
          <div>
            <p className="caption text-muted-foreground mb-1">Uren Gewerkt</p>
            <p className="font-semibold text-foreground">{referral?.hoursWorked}u</p>
          </div>
        )}
        {referral?.revenue !== undefined && (
          <div>
            <p className="caption text-muted-foreground mb-1">Omzet</p>
            <p className="font-semibold text-foreground">€{referral?.revenue?.toLocaleString('nl-NL')}</p>
          </div>
        )}
        <div>
          <p className="caption text-muted-foreground mb-1">Commissie</p>
          <p className="font-semibold text-success">€{referral?.commission?.toLocaleString('nl-NL')}</p>
        </div>
        <div>
          <p className="caption text-muted-foreground mb-1">Percentage</p>
          <p className="font-semibold text-foreground">{referral?.commissionRate}%</p>
        </div>
      </div>
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <span className="caption text-muted-foreground">
          Aangebracht op {new Date(referral.referredDate)?.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' })}
        </span>
        <Link 
          to={`/job-details-and-applications?id=${referral?.id}`}
          className="text-primary hover:text-primary/80 transition-smooth caption font-medium flex items-center gap-1"
        >
          Details
          <Icon name="ChevronRight" size={14} />
        </Link>
      </div>
    </div>
  );
};

export default ReferralCard;